;(function () {
  angular
    .module('contrast.notifications')
    .controller('ModalEditAlertInstanceCtrl', ModalEditAlertInstanceCtrl)

  function ModalEditAlertInstanceCtrl(
    $scope,
    $uibModalInstance,
    $q,
    $translate,
    logger,
    alert,
    title,
    ApplicationFactory,
    AlertFactory,
    TagFactory,
    UserFactory,
    ErrorService,
    AlertService
  ) {
    'ngInject'

    var translGlobal = {
      title_all_applications: $translate.instant('title_all_applications'),
      title_all_users: $translate.instant('title_all_users')
    }

    angular.extend($scope, {
      title: title,
      model: {
        frequency: AlertService.getFrequency(),
        conditions: AlertService.getConditions(),
        recipient: '',
        isVulnType: 1
      },
      entireApps: [],
      alert: {
        recipients: [],
        tags: [],
        conditions: [],
        frequency: 'daily',
        apps: []
      },
      select: {
        users: [],
        users_rasp: []
      }
    })

    angular.extend($scope, {
      changeOptionsArray: function (condition) {
        AlertService.changeOptionsArray(condition)
      },

      updateSelect: function (item, model) {
        if (model === 'All') {
          $scope.alert.recipients = ['All']
        } else {
          var index = _.indexOf($scope.alert.recipients, 'All')
          if (index != -1) {
            $scope.alert.recipients = $scope.alert.recipients
              .slice(0, index)
              .concat(
                $scope.alert.recipients.slice(
                  index + 1,
                  $scope.alert.recipients.length
                )
              )
          }
        }
      },

      addCondition: function () {
        $scope.alert.conditions.push({
          condition: '',
          qualifier: 'is',
          detail: '',
          qualifierArray: AlertService.getQualifierCategory(),
          detailArray: AlertService.getDetailCategory(),
          isInputDetail: false
        })
      },

      deleteCondition: function (condition) {
        var idx = $scope.alert.conditions.indexOf(condition)
        if (idx > -1) {
          $scope.alert.conditions.splice(idx, 1)
        }
      },

      ok: function () {
        var alertForm = angular.copy($scope.alert)

        alertForm.conditions = AlertService.formatConditions(
          alertForm.conditions
        )

        if (_.indexOf(alertForm.recipients, 'All') > -1) {
          alertForm.recipients = []
          alertForm.allUsers = true
        } else {
          alertForm.allUsers = false
        }

        AlertService.removeEmptyConditions(alertForm)

        AlertFactory.editAlert(alert.alert_id, alertForm).then(
          function (response) {
            logger.logSuccess(response.data.messages[0])
            $uibModalInstance.close()
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel')
      },

      validateForm: function () {
        if (
          !$scope.alert.name ||
          !$scope.alert.description ||
          ($scope.alert.apps.length == 0 && $scope.alert.tags.length == 0)
        ) {
          return false
        }

        if ($scope.alert.recipients.length == 0 || !validConditions()) {
          return false
        }

        return true
      }
    })

    function init() {
      var promises = []
      promises.push(loadApplications())
      promises.push(loadUsers())
      promises.push(loadTags())

      $q.all(promises).then(function () {
        $scope.alert = AlertService.convertToAlertView(
          alert,
          translGlobal.title_all_applications,
          $scope.entireApps.length
        )
        angular.forEach($scope.alert.recipients, function (recipient) {
          var index = _.findIndex($scope.select.users, function (e) {
            return e.uid === recipient
          })
          if (index === -1) {
            $scope.select.users.push({ uid: recipient, full_name: recipient })
          }
        })

        angular.forEach($scope.alert.tags, function (tag) {
          var index = _.findIndex($scope.select.tags, function (e) {
            return e.text === tag
          })
          if (index === -1) {
            $scope.select.tags.push({ text: tag })
          }
        })
      })
    }

    function loadApplications() {
      var data = { includeMerged: true }
      return ApplicationFactory.getApplicationsName(data).then(
        function (response) {
          $scope.entireApps = response.data.applications
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadUsers() {
      return UserFactory.getUsersBase(false, true).then(
        function (response) {
          $scope.select.users = angular.copy(response.data.users)
          var size = $scope.select.users.length
          $scope.select.users.unshift({
            uid: 'All',
            full_name: translGlobal.title_all_users + ' (' + size + ')'
          })
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadTags() {
      return TagFactory.getApplicationsTags().then(
        function (response) {
          $scope.select.tags = []
          angular.forEach(response.data.tags, function (tag) {
            var tagO = {}
            tagO['value'] = tag
            tagO['text'] = tag
            $scope.select.tags.push(tagO)
          })
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function validConditions() {
      if ($scope.alert.conditions.length == 0) {
        return false
      }

      var isValid = false
      for (var i = 0; i < $scope.alert.conditions.length; i++) {
        var condition = $scope.alert.conditions[i]
        if (condition.condition && condition.qualifier && condition.detail) {
          isValid = true
          break
        }
      }
      return isValid
    }

    init()
  }
})()
